import { render, staticRenderFns } from "./partnerForm.vue?vue&type=template&id=25ab9980&scoped=true"
import script from "./partnerForm.vue?vue&type=script&lang=js"
export * from "./partnerForm.vue?vue&type=script&lang=js"
import style1 from "./partnerForm.vue?vue&type=style&index=1&id=25ab9980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab9980",
  null
  
)

export default component.exports